<template>
  <v-dialog max-width="400" v-model="isVisible" @click:outside="close()" persistent eager>
    <v-card class="container-card px-5 py-3" color="#21343b" width="auto">
      <v-container style="background-color: #21343b" class="py-6">
        <v-row no-gutters align="center" justify="start">
          <v-col cols="12">
            <span class="confirm-title">{{ title }}</span>
          </v-col>
          <v-col class="mt-2" cols="12" align="start" justify="start">
            <span class="confirm-content">{{ message }}</span>
          </v-col>
        </v-row>
        <v-row class="container-btn mt-5 mr-4" no-gutters align="start" justify="center">
          <v-col>
            <v-btn
              block
              height="40"
              elevation="0"
              color="#ff575f"
              @click.native="confirm"
              :loading="isDeleteLoading"
              class="mr-5"
            >
              {{ confirmLabel }}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn class="ml-4" block height="40" elevation="0" color="#869399" @click.native="close">
              {{ cancelLabel }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import Toast from '@/views/meeting/component/Toast'
export default {
  name: 'ConfirmModal',
  props: {
    syncViaProps: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    cancelLabel: {
      type: String,
      default: '',
    },
    confirmLabel: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    closeOnConfirm: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      promise: undefined,
      beforeConfirm: () => {},
      beforeCancel: () => {},
      internalVisible: false,
      resolvePromise: undefined,
      rejectPromise: undefined,
      isDeleteLoading: false,
    }
  },
  computed: {
    isVisible() {
      return this.visible || this.internalVisible
    },
  },
  methods: {
    // beforeClose(done) {
    //   done()
    //   this.updateVisible(false)
    // },
    async close() {
      let done = () => {
        this.updateVisible(false)
        this.rejectPromise()
      }

      if (this.isVisible && this.beforeCancel) {
        await this.beforeCancel(done)
      }
      done()
    },
    updateVisible(value) {
      this.isDeleteLoading = false
      if (this.syncViaProps) {
        this.$emit('update:visible', value)
      } else {
        this.internalVisible = value
      }
    },
    async confirm() {
      try {
        this.isDeleteLoading = true
        let done = () => {
          this.resolvePromise()
        }
        if (this.beforeConfirm) {
          await this.beforeConfirm(done)
        }
        if (this.closeOnConfirm) {
          done()
        }
      } catch (error) {
        console.log(error)
        // notify(this, 'Error', this.errorCode, 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.errorCode,
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.updateVisible(false)
      }
    },
    show() {
      this.updateVisible(true)
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
  },
}
</script>
<style scoped>
.v-dialog__content >>> .v-dialog {
  overflow: hidden;
}
.container-card {
  border-radius: 24px !important;
}
.confirm-title {
  font-weight: bold;
  font-size: 20px;
  color: white;
}

.confirm-content {
  font-size: 14px;
  color: #96a7af;
}
.container-btn >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
</style>
